import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 13,
  steps: [
    addColumns({
      table: 'chats',
      columns: [{ name: 'has_client_message', type: 'boolean' }]
    })
  ]
}
